import { Icon } from '@main/core-ui';
import type { PolicyVersion } from '@main/pc-types';
import PolicyVersionSlider from '@main/privacy-center/src/components/PolicyVersionSlider';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

import { policyVersionsMessages } from './messages';
import {
  ChangesSwitchContainer,
  ClassOverrides,
  CloseButtonWrapper,
  FooterWrapper,
  SliderWrapper,
  SwitchLabel,
  ViewPastVersionsIconWrapper,
  ViewPastVersionsLabel,
  ViewPastVersionsWrapper,
} from './wrappers';

/**
 * The PolicyVersions props
 */
export interface PolicyVersionsProps {
  /** The different versions of the privacy policy, sorted least to most recent */
  versions: PolicyVersion[];
  /** The initial mode setting for the policy view */
  initialCompareMode?: boolean;
  /** The default policy version */
  defaultVersionInd?: number;
}

/**
 * The Page PolicyVersions
 */
function PolicyVersions({
  versions,
  initialCompareMode = false,
  defaultVersionInd = versions.length - 1,
}: PolicyVersionsProps): JSX.Element {
  const { formatMessage } = useIntl();
  const [currentCompareMode, setCurrentCompareMode] =
    useState(initialCompareMode);
  const [, setSelectedVersionInd] = useState(defaultVersionInd);

  return (
    <div>
      {!currentCompareMode && (
        <ViewPastVersionsWrapper
          onClick={() => {
            setCurrentCompareMode(true);
          }}
        >
          <ViewPastVersionsIconWrapper>
            <Icon type="clock-arrow-back" size={16} />
          </ViewPastVersionsIconWrapper>
          <ViewPastVersionsLabel>
            {formatMessage(policyVersionsMessages.pastVersions)}
          </ViewPastVersionsLabel>
        </ViewPastVersionsWrapper>
      )}
      {currentCompareMode && (
        <FooterWrapper>
          <ClassOverrides />
          <CloseButtonWrapper onClick={() => setCurrentCompareMode(false)}>
            <Icon type="close" size={24} />
          </CloseButtonWrapper>
          <SliderWrapper>
            <PolicyVersionSlider
              versions={versions}
              onPolicyIndChange={setSelectedVersionInd}
            />
          </SliderWrapper>
          <ChangesSwitchContainer>
            <SwitchLabel>
              {formatMessage(policyVersionsMessages.changes)}
            </SwitchLabel>
          </ChangesSwitchContainer>
        </FooterWrapper>
      )}
    </div>
  );
}

export default PolicyVersions;
